module.exports = __webpack_public_path__ + "img/2.51c4eed0.png";